
import React from 'react';
import { CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Heart, X } from 'lucide-react';

interface SwipeCardFooterProps {
  onLike: () => void;
  onPass: () => void;
  isAnimating: boolean;
}

const SwipeCardFooter: React.FC<SwipeCardFooterProps> = ({
  onLike,
  onPass,
  isAnimating
}) => {
  return (
    <CardFooter className="flex justify-between bg-muted/30 py-3">
      <Button
        variant="outline"
        size="lg"
        className="rounded-full h-12 w-12 p-0 flex items-center justify-center hover:bg-red-100 hover:border-red-300 transition-colors"
        onClick={onPass}
        disabled={isAnimating}
      >
        <X className="h-6 w-6" />
      </Button>
      
      <Button
        variant="outline"
        size="lg"
        className="rounded-full h-12 w-12 p-0 flex items-center justify-center hover:bg-green-100 hover:border-green-300 transition-colors"
        onClick={onLike}
        disabled={isAnimating}
      >
        <Heart className="h-6 w-6" />
      </Button>
    </CardFooter>
  );
};

export default SwipeCardFooter;
